import { StatCard, StatCardGrid } from '../../../components/common';
import { fmtCurrency } from '../../../utils/formatNumber';
import { formatDate } from '../../../utils/dateUtils';
import styles from '../Reports.module.css';

export default function ItemRegisterReport({ data }) {
  if (!data) return null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <StatCardGrid cols={2}>
        <StatCard label="Total Items Collected" value={String(data.totalItems || 0)} />
        <StatCard label="Total Estimated Value" value={fmtCurrency(data.totalInr)} valueColor="green" />
      </StatCardGrid>

      <div className="card">
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Receipt No</th>
                <th>Category</th>
                <th>Description</th>
                <th className={styles.amtRight}>Estimated Value (₹)</th>
              </tr>
            </thead>
            <tbody>
              {(!data.receipts || data.receipts.length === 0) && (
                <tr><td colSpan={5} className="empty-state">No item donations in period.</td></tr>
              )}
              {data.receipts?.map((r, i) => (
                <tr key={i}>
                  <td>{formatDate(r.receiptDate)}</td>
                  <td><code>{r.receiptNo}</code></td>
                  <td>{r.donationCategory?.name || '—'}</td>
                  <td>{r.narration || '—'}</td>
                  <td className={styles.amtRight}>{fmtCurrency(r.amountInr)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
